// extracted by mini-css-extract-plugin
module.exports = {"list":"location_list__x1KAi","item":"location_item___g6_D","cancel":"location_cancel__Zdfdd"};